import MuiGrid from "@mui/material/Grid";
import type { GridProps as MuiGridProps } from "@mui/material/Grid";

import { GridItem } from "./grid-item";

export type GridProps = MuiGridProps;

function GridBase({
  children,
  columns,
  container = true,
  direction,
  spacing,
  xs,
  xl,
  wrap,
  zeroMinWidth,
  justifyContent = "space-between",
  alignItems = "center",
  textAlign,
  sx,
}: GridProps) {
  return (
    <MuiGrid
      columns={columns}
      direction={direction}
      container={container}
      spacing={spacing}
      xs={xs}
      xl={xl}
      wrap={wrap}
      zeroMinWidth={zeroMinWidth}
      justifyContent={justifyContent}
      alignItems={alignItems}
      textAlign={textAlign}
      sx={sx}
      item
    >
      {children}
    </MuiGrid>
  );
}

type GridComponent = typeof GridBase & {
  Item: typeof GridItem;
};

export const Grid = GridBase as GridComponent;
Grid.Item = GridItem;
